import { api } from "./client";
import type { ChatReply, SchedulerJob } from "@/types";

export async function sendChat(message: string): Promise<ChatReply> {
  const { data } = await api.post<ChatReply>("/coach/chat", { message });
  return data;
}

interface GeneratedWeeklyReview {
  status?: "generated";
  model_used: string;
  week_start_date: string;
  phase: string;
  target_weekly_tss: number;
  workouts_created: number;
  intervals_push: { pushed: number; errors?: number; skipped_no_creds?: boolean };
}

export type WeeklyReviewResult = GeneratedWeeklyReview
  | { status: "cached"; model_used: string | null; workouts_created: number }
  | { status: "skipped"; reason: string };

export async function triggerWeeklyReview(): Promise<WeeklyReviewResult> {
  const { data } = await api.post<WeeklyReviewResult>("/coach/trigger/weekly-review");
  return data;
}

export interface DailyCheckResult {
  model_used: string;
  context: Record<string, unknown>;
  reply: string;
}

export async function triggerDailyCheck(): Promise<DailyCheckResult> {
  const { data } = await api.post<DailyCheckResult>("/coach/trigger/daily-check");
  return data;
}

export async function listJobs(): Promise<{ count: number; running: boolean; jobs: SchedulerJob[] }> {
  const { data } = await api.get("/coach/jobs");
  return data;
}
